import { useTranslation } from '@numistic/i18n'
import { Alert, Button } from '@numistic/ui'
import type { ErrorComponentProps } from '@tanstack/react-router'

import { useErrorText } from '../lib/errors.js'

/** Ошибка рендера или загрузки маршрута: понятное сообщение вместо заглушки роутера. */
export function ErrorView({ error, reset }: ErrorComponentProps) {
  const { t } = useTranslation()
  const errorText = useErrorText()
  if (import.meta.env.DEV) console.error(error)
  return (
    <div className="grid max-w-md gap-3">
      <Alert variant="destructive">{errorText.request(error)}</Alert>
      <Button variant="outline" className="justify-self-start" onClick={reset}>
        {t('common.retry')}
      </Button>
    </div>
  )
}
